import type { FaireProductEntity } from "../../entity_types/product";

export const p_jt64pgatae: FaireProductEntity = {
  token: "p_jt64pgatae",
  type: "product",
  name: "Jesus Saves Bro Camo Kids Hat",
  brandToken: "b_ze9xj3576d",
  brandName: "Indian Creek Threads",
  imageUrl:
    "https://cdn.faire.com/fastly/be563af88e3f6e57065af314ecaaf9272b38d9b6633d67f973a7d920408ac391.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7fbee8f5ca92082e3b28a07e69dde90a45651579a0da25ec24d3389b75690432.jpeg",
    "https://cdn.faire.com/fastly/1fdf10167dee5d3e177f7e648010b5ec4bbc46caf753fca1dcfd71936ab3937f.jpeg",
    "https://cdn.faire.com/fastly/640e600fef47eae392eb9234759957f02cfcb9ac1a2efdddb6ef127bcab046d0.jpeg",
    "https://cdn.faire.com/fastly/d80b921bf4e1faa5dd538a0afcf452d163877e682f4a37aaff98b17886dc77bc.jpeg",
  ],
  priceDollars: 15,
  description:
    "Camo Mesh Back Flat Bill Hat\nDTF Printed\nInfant/Toddler- OSFM Ages 0-3y: 48cm circumference\nYouth-OSFM Ages 3-10: 53cm circumference\nAdjustable snapback\nGreen mesh back\n**ROPES ARE CURRENTLY OUT OF STOCK, HATS WILL NOT HAVE ROPE ON THEM, BUT LOOK THE SAME OTHERWISE.**",
  tags: [],
  msrpDollars: 25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:04.039Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
